import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../app/config';
import { TicketDetail } from './TicketDetail';

export function TicketDetailPage({
  scope = 'user',
}: {
  scope?: 'user' | 'support';
}): JSX.Element {
  const { ticketId } = useParams<{ ticketId: string }>();

  if (!ticketId) {
    return <Navigate to={ROUTES.tickets} replace />;
  }

  return <TicketDetail ticketId={ticketId} scope={scope} />;
}
